import { render, staticRenderFns } from "./QRCodes.vue?vue&type=template&id=0c7188c1&"
import script from "./QRCodes.vue?vue&type=script&lang=js&"
export * from "./QRCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports